import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Lock, User, ArrowRight, ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';
import BrandLogo from '../components/BrandLogo';
import { clientApi } from '../api';

const ClientLogin = () => {
  const { clientSlug } = useParams();
  const nav = useNavigate();
  const [info, setInfo] = useState(null);
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const i = await clientApi.getInfo(clientSlug);
        setInfo(i);
        const saved = clientApi.displayName(clientSlug);
        if (saved) setName(saved);
        if (clientApi.hasToken(clientSlug) && saved) {
          try { await clientApi.me(clientSlug); nav(`/c/${clientSlug}/home`, { replace: true }); return; }
          catch { clientApi.logout(clientSlug); }
        }
      } catch (err) { toast.error('Codice cliente non trovato'); nav('/'); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientSlug, nav]);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return toast.error('Inserisci il tuo nome');
    setBusy(true);
    try {
      await clientApi.unlock(clientSlug, { password, display_name: name.trim() });
      toast.success(`Benvenuto/a ${name}`);
      nav(`/c/${clientSlug}/home`);
    } catch (err) { toast.error(err?.response?.data?.detail || 'Password errata'); }
    finally { setBusy(false); }
  };

  if (!info) return null;

  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-black">
      {info.cover_url && <img src={info.cover_url} alt="" className="absolute inset-0 w-full h-full object-cover opacity-80" />}
      <div className="absolute inset-0 bg-gradient-to-tr from-black via-black/70 to-black/40" />

      <Link to="/" className="absolute top-6 left-6 z-20 flex items-center gap-2 text-white/80 hover:text-white text-sm">
        <ArrowLeft className="w-4 h-4" /> Home
      </Link>

      <div className="relative z-10 min-h-screen grid md:grid-cols-2 gap-8 items-center px-6 md:px-12 py-16">
        <div className="fade-in">
          <BrandLogo size="md" />
          <p className="text-[#C9A961] uppercase tracking-[0.3em] text-xs mb-3">Area riservata</p>
          <h1 className="font-display text-white text-5xl md:text-7xl italic leading-none">{info.name}</h1>
          <p className="text-slate-300 mt-6 max-w-md">Inserisci la password che ti ha inviato Nicola per accedere ai tuoi lavori.</p>
        </div>

        <form onSubmit={submit} className="bg-white/95 backdrop-blur rounded-2xl p-8 max-w-md md:justify-self-end w-full shadow-2xl">
          <div className="flex items-center gap-2 mb-5">
            <Lock className="w-5 h-5 text-[#B8944B]" />
            <h3 className="font-semibold text-slate-900">Accesso protetto</h3>
          </div>
          <label className="block mb-4">
            <span className="text-sm font-medium text-slate-700">Il tuo nome</span>
            <div className="mt-1 flex items-center gap-2 border border-slate-200 rounded-xl px-3 py-2.5 focus-within:border-[#C9A961] focus-within:ring-2 focus-within:ring-[#F7F1E1]">
              <User className="w-4 h-4 text-slate-400" />
              <input type="text" name="client-name" autoComplete="off" data-lpignore="true" data-form-type="other" data-testid="client-name-input" value={name} onChange={e=>setName(e.target.value)} required placeholder="Es. Andrea o la tua email" className="flex-1 outline-none bg-transparent text-slate-900" />
            </div>
          </label>
          <label className="block mb-6">
            <span className="text-sm font-medium text-slate-700">Password</span>
            <div className="mt-1 flex items-center gap-2 border border-slate-200 rounded-xl px-3 py-2.5 focus-within:border-[#C9A961] focus-within:ring-2 focus-within:ring-[#F7F1E1]">
              <Lock className="w-4 h-4 text-slate-400" />
              <input type="password" name="client-password" autoComplete="new-password" data-lpignore="true" data-testid="client-password-input" value={password} onChange={e=>setPassword(e.target.value)} required placeholder="••••••••" className="flex-1 outline-none bg-transparent text-slate-900" />
            </div>
          </label>
          <button disabled={busy} className="btn-primary w-full justify-center">
            Entra <ArrowRight className="w-4 h-4" />
          </button>
        </form>
      </div>
    </div>
  );
};

export default ClientLogin;
